export const diffPart = {
  equal: 'equal',
  removed: 'removed',
  added: 'added',
};

const MAX_TABLE_SIZE = 250000;

const tokenize = (text) => (text ?? '').match(/\s+|\S+/g) ?? [];

const commonSuffixLengths = (a, b) => {
  const table = Array.from({ length: a.length + 1 }, () => new Array(b.length + 1).fill(0));
  for (let i = a.length - 1; i >= 0; i -= 1) {
    for (let j = b.length - 1; j >= 0; j -= 1) {
      table[i][j] = a[i] === b[j] ? table[i + 1][j + 1] + 1 : Math.max(table[i + 1][j], table[i][j + 1]);
    }
  }
  return table;
};

const append = (parts, type, text) => {
  const last = parts[parts.length - 1];
  if (last !== undefined && last.type === type) {
    last.text += text;
    return;
  }
  parts.push({ type, text });
};

export const diffWords = (before, after) => {
  const a = tokenize(before);
  const b = tokenize(after);
  const parts = [];

  if (a.length * b.length > MAX_TABLE_SIZE) {
    a.forEach((token) => append(parts, diffPart.removed, token));
    b.forEach((token) => append(parts, diffPart.added, token));
    return parts;
  }

  const table = commonSuffixLengths(a, b);
  let i = 0;
  let j = 0;
  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) {
      append(parts, diffPart.equal, a[i]);
      i += 1;
      j += 1;
    } else if (table[i + 1][j] >= table[i][j + 1]) {
      append(parts, diffPart.removed, a[i]);
      i += 1;
    } else {
      append(parts, diffPart.added, b[j]);
      j += 1;
    }
  }
  a.slice(i).forEach((token) => append(parts, diffPart.removed, token));
  b.slice(j).forEach((token) => append(parts, diffPart.added, token));
  return parts;
};
